<template>
  <SharedPublishingArticle
    :pageTitle="$t('components.sub.navigation.press-releases')"
    :allArticlesUrl="sectionRoot"
    :viewAllArticlesLink="$t('scenes.publishing.view-all-press-releases')"
    :viewAllArticlesButton="$t('scenes.publishing.view-all-press-releases-button')"
    :article="pr"
    :author="null"
  />
</template>

<script>
  import SharedPublishingArticle from '~/components/shared/publishing/article.vue'

  export default {
    name: 'PressRelease',

    components: {
      SharedPublishingArticle,
    },

    async asyncData({ app, params, query, $axios, error, redirect }) {
      const endpointRoot = '/v2/press-releases'
      const sectionRoot = '/about-us/media-center#press-releases'

      let pr = null
      let cacheQuery = ''

      const queries = Object.keys(query)
      if (queries.length > 0 && queries.includes('clear_cache')) {
        cacheQuery = `?clear_cache${query.clear_cache ? '=' + query.clear_cache : ''}`
      }

      const URI = `${endpointRoot}/${params.slug}${cacheQuery}`
      const encodedURI = encodeURI(URI)

      try {
        const response = await $axios.get(encodedURI)
        pr = response.data
      } catch (e) {
        if (e.response?.data?.code === 'common.not-found') {
          redirect(301, app.localePath(sectionRoot))
        } else {
          error(e)
        }

        return
      }

      return { pr, sectionRoot }
    },

    created() {
      this.$store.commit('set_mobile_header_text', '')
    },
  }
</script>
